module.exports = __webpack_public_path__ + "static/img/19-Cardiff-Central-Square-regeneration.252f29b7.jpg";